// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterLinkColumn_container__36p2g","heading":"FooterLinkColumn_heading__2-9-x","sending":"FooterLinkColumn_sending__2O6mO"};